import { Component, inject } from '@angular/core';
import { StandTypeService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  StandTypeCreateDto,
  StandTypeDto,
  StandTypeExcelDownloadDto,
  StandTypeUpdateDto,
} from '../proxy/planning/dtos/stand-type';
import { STANDTYPE_CONFIG, STANDTYPE_FIELDS } from './stand-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-stand-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, StandTypeService, ConfirmationService],
  templateUrl: './stand-type.html',
  styleUrl: './stand-type.scss',
})
export class StandType extends BaseCrudComponent<
  StandTypeDto,
  StandTypeCreateDto,
  StandTypeUpdateDto,
  StandTypeExcelDownloadDto
> {
  service = inject(StandTypeService);
  config = STANDTYPE_CONFIG;
  fields = STANDTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: StandTypeDto): StandTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      lastCharacter: data.lastCharacter,
      isComercial: data.isComercial,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'StandType';
  }
}
